export { default } from '@/components/Maps/DesktopMapsScreen';
